module.exports = __webpack_public_path__ + "static/2-year-old@large-c50c8a563e8b240cdbd6abfea1801ada.jpg";